module.exports = __webpack_public_path__ + "/img/ChipArray4SideFlat-Custom-Footprint-LBw2z7.svg";